<template>
  <div>
    <div class="page-head">
      <div>
        <h2>方案模板管理</h2>
        <p>维护高端定制页展示的参考方案模板，不用于灵感探索。</p>
      </div>
      <el-button type="primary" @click="openCreate">新增方案模板</el-button>
    </div>

    <el-card shadow="never">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="关键词">
          <el-input v-model="filters.keyword" placeholder="方案名称/标签/描述/正文" clearable />
        </el-form-item>
        <el-form-item label="展示状态">
          <el-select v-model="filters.status" placeholder="全部" clearable>
            <el-option label="展示中" value="active" />
            <el-option label="已隐藏" value="inactive" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchList">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <paged-table :rows="rows" :loading="loading" :page="page" :page-size="pageSize" :total="total" @page-change="page = $event; fetchList()" @size-change="pageSize = $event; page = 1; fetchList()">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column label="方案名称" min-width="180"><template slot-scope="{ row }">{{ row.name || row.title }}</template></el-table-column>
        <el-table-column prop="duration" label="方案标签" width="140" />
        <el-table-column prop="suitable_people" label="适合人群" min-width="180" />
        <el-table-column prop="description" label="摘要" min-width="220" show-overflow-tooltip />
        <el-table-column prop="status" label="小程序展示" width="160">
          <template slot-scope="{ row }"><publish-switch :value="row.status" @change="changeStatus(row, $event)" /></template>
        </el-table-column>
        <el-table-column prop="sort_order" label="排序" width="130">
          <template slot-scope="{ row }"><sort-input :value="Number(row.sort_order || 0)" @change="changeSort(row, $event)" /></template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openEdit(row)">编辑</el-button>
            <el-button type="text" class="danger-text" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </paged-table>
    </el-card>

    <el-dialog :title="drawerMode === 'create' ? '新增方案模板' : '编辑方案模板'" :visible.sync="drawerVisible" width="760px" destroy-on-close>
      <el-form ref="form" class="drawer-form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="方案名称" prop="name"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="方案标签"><el-input v-model="form.duration" placeholder="如：4 日经典 / 亲子研学 / 私享深度" /></el-form-item>
        <el-form-item label="适合人群"><el-input v-model="form.suitable_people" /></el-form-item>
        <el-form-item label="打开方式"><el-select v-model="form.action_type"><el-option label="查看方案详情" value="detail"/><el-option label="跳转关联线路" value="route"/><el-option label="直接填写定制" value="customize"/></el-select></el-form-item>
        <el-form-item v-if="form.action_type === 'route'" label="关联线路"><el-select v-model="form.linked_route_id" filterable><el-option v-for="item in routes" :key="item.id" :label="item.name || item.title" :value="item.id"/></el-select></el-form-item>
        <el-form-item label="封面图"><asset-upload v-model="form.cover_url" category="route-plans" /></el-form-item>
        <el-form-item label="摘要"><el-input v-model="form.description" type="textarea" :rows="3" /></el-form-item>
        <el-form-item label="方案内容"><rich-text-editor v-model="form.content" /></el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="drawerVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PagedTable from "../components/PagedTable.vue";
import PublishSwitch from "../components/PublishSwitch.vue";
import SortInput from "../components/SortInput.vue";
import AssetUpload from "../components/AssetUpload.vue";
import RichTextEditor from "../components/RichTextEditor.vue";
import { changeResourceStatus, createResource, deleteResource, listResource, updateResource } from "../api/resources";

export default {
  name: "RoutePlansManage",
  components: { AssetUpload, PagedTable, PublishSwitch, RichTextEditor, SortInput },
  data() {
    return {
      loading: false,
      saving: false,
      drawerVisible: false,
      drawerMode: "create",
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filters: { keyword: "", status: "" },
      form: this.emptyForm(),
      routes: [],
      rules: { name: [{ required: true, message: "请填写方案名称", trigger: "blur" }] }
    };
  },
  mounted() {
    this.fetchList();
    this.fetchRoutes();
  },
  methods: {
    emptyForm() {
      return {
        name: "",
        title: "",
        duration: "",
        suitable_people: "",
        cover_url: "",
        description: "",
        content: "",
        action_type: "customize",
        linked_route_id: 0
      };
    },
    async fetchRoutes(){const res=await listResource("routes",{status:"active",page:1,pageSize:100});this.routes=res.data&&res.data.items?res.data.items:[];},
    async fetchList() {
      this.loading = true;
      try {
        const res = await listResource("route-plans", { ...this.filters, page: this.page, pageSize: this.pageSize });
        this.rows = res.data && res.data.items ? res.data.items : [];
        this.total = res.data && res.data.total ? res.data.total : 0;
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.filters = { keyword: "", status: "" };
      this.page = 1;
      this.fetchList();
    },
    openCreate() {
      this.drawerMode = "create";
      this.form = this.emptyForm();
      this.drawerVisible = true;
    },
    openEdit(row) {
      this.drawerMode = "edit";
      this.form = { ...this.emptyForm(), ...row, name: row.name || row.title || "" };
      this.drawerVisible = true;
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.saving = true;
        try {
          const payload = { ...this.form, title: this.form.name };
          if (this.drawerMode === "create") await createResource("route-plans", payload);
          else await updateResource("route-plans", this.form.id, payload);
          this.$message.success("方案模板已保存");
          this.drawerVisible = false;
          this.fetchList();
        } finally {
          this.saving = false;
        }
      });
    },
    async changeStatus(row, status) {
      await changeResourceStatus("route-plans", row.id, status);
      this.$message.success(status === "active" ? "方案模板已展示" : "方案模板已隐藏");
      this.fetchList();
    },
    async changeSort(row, sortOrder) {
      await updateResource("route-plans", row.id, { ...row, sort_order: sortOrder });
      this.$message.success("排序已更新");
      this.fetchList();
    },
    remove(row) {
      this.$confirm("确定删除该方案模板吗？", "删除方案模板", { type: "warning" })
        .then(async () => {
          await deleteResource("route-plans", row.id);
          this.$message.success("方案模板已删除");
          this.fetchList();
        })
        .catch(() => {});
    }
  }
};
</script>
